import { render, staticRenderFns } from "./HotelCard.vue?vue&type=template&id=a3116c94&"
import script from "./HotelCard.vue?vue&type=script&lang=ts&"
export * from "./HotelCard.vue?vue&type=script&lang=ts&"
import style0 from "./HotelCard.vue?vue&type=style&index=0&id=a3116c94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports